import React, { FC } from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';
import { COLORS } from '../../constants';

const CenteredContainer = React.memo(styled.div`
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%);
`);

const StyledCircularProgress = React.memo(styled(CircularProgress)`
  color: ${COLORS.SKY_BLUE};
`);

export interface MessageLoadingIndicatorProps {
  size?: number;
  className?: string;
}

const MessageLoadingIndicator: FC<MessageLoadingIndicatorProps> = ({ size = 24, className }) => (
  <CenteredContainer className={className}>
    <StyledCircularProgress size={size} disableShrink />
  </CenteredContainer>
);

export default React.memo(MessageLoadingIndicator);
